$(document).ready(function(){
  // Function to get URL parameter
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Save ref parameter from URL to localStorage if it exists
  var refFromUrl = getUrlParameter('ref');
  if (refFromUrl) {
    try {
      localStorage.setItem('ref', refFromUrl);
    } catch (e) {
      console.error('Error saving ref to localStorage:', e);
    }
  }

  // console.log("Scripe Added;");
  // var text = $('.custom_form_cls .shogun-form-box .shogun-form-success-msg span');

  // $('.app_form_btn .shg-btn').click(function(){
  //   if ($(text).css('visibility') == 'visible') {
  //   console.log("suceesss")
  //   $('.app_btn_div').css('display','block');
  // }
  // });

  setTimeout(function(){
    $('.video-popup-main').show();
  },1500);

  $('.popclose-btn').click(function(){
    $(".video-popup-video").remove();
    $('.video-popup-main').hide();
  });

  $('#s-303a1ec7-9426-492e-af7f-359d8ed177a9').click(function(){
    setTimeout(function(){
      window.location.href = "/pages/step-2-genius-insight-checkout-hardware";
    },1500);
  });
  $('#s-ac98d0f8-824f-4b8c-81e7-071a240230c9').click(function(){
    setTimeout(function(){
      window.location.href = "/pages/step4-geniusinsight-checkout-training";
    },1500);
  });
  $('#s-ad6f6406-16ff-405d-a80e-3ebcfb74f229').click(function(){
    setTimeout(function(){
      window.location.href = "/pages/step4-geniusinsight-checkout-training";
    },1500);
  });
  $('#s-a74a9753-9fe3-45f0-a50e-9ac157f1b646').click(function(){
    setTimeout(function(){
      window.location.href = "/pages/step4-geniusinsight-checkout-training";
    },1500);
  });
  $('#s-1e70a310-6a75-4a02-9cec-b868034a47a3').click(function(){
    setTimeout(function(){
      window.location.href = "/pages/step4-geniusinsight-checkout-training";
    },1500);
  });

  $('.custom_form_box .shogun-form-box-submit').click(function(){
    var formData_1 = {
                name: $('#input-s-11476ea6-6c08-47c3-9d31-596d39b89791').val(),
                email: $('#input-s-0e805c3a-6c7c-42da-b5d3-2fdd7c8e5e92').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-f0abf1b9-d63d-4b31-81eb-5ce07b410764').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_app_div').css('display','block');
        $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_1),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

// new testing

$('.custom_form_box-d1 .shogun-form-box-submit').click(function(){
    var formData_11 = {
                name: $('#input-s-e480f6ca-4d16-442c-9491-4dd45719c6b6').val(),
                email: $('#input-s-9ce87719-847f-4e66-b3fe-2db83daf6f8e').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-b3338525-8178-40c2-9449-a808f682b38e').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box-d1 .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_app_div').css('display','block');
        $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_11),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });


  $('.custom_form_box_two .shogun-form-box-submit').click(function(){
    var formData_2 = {
                name: $('#input-s-e9d44a72-6826-47f0-b59d-64fc49b1fd97').val(),
                email: $('#input-s-8c1543c9-e0ae-408c-ba57-024696a8f815').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-8de66f8c-e503-4451-bb80-d7e7773bee67').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_two .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_two_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_2),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

// form new page form 2


  $('.custom_form_box_two-2 .shogun-form-box-submit').click(function(){
    var formData_22 = {
                name: $('#input-s-b7a2c0fd-a243-4e7a-bb91-20eb2ef300cf').val(),
                email: $('#input-s-46aa2882-91f9-4c87-905a-6873fd180e66').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-16ddd924-0eca-4683-85da-ec57197663ce').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_two-2 .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_two_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_22),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

  $('.custom_form_box_three .shogun-form-box-submit').click(function(){
    var formData_3 = {
                name: $('#input-s-779a8ef0-875a-4eef-9074-e8155ed7c301').val(),
                email: $('#input-s-5c065e0b-5399-4305-a002-e1281188371c').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-b6c7f0ef-d048-42a6-bdbb-70c3e2ce27f8').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_three .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_three_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_3),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

// new page form 3

  $('.custom_form_box_three-3 .shogun-form-box-submit').click(function(){
    var formData_6 = {
                name: $('#input-s-18cf4939-d734-445e-be2e-3e02cc09c7a0').val(),
                email: $('#input-s-7eb97350-c0e7-4288-95dc-39ddf5df2337').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-d0e10510-c3a1-4003-b04f-e5147c262fc6').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_three-3 .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_three_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_6),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

  $('.custom_form_box_four .shogun-form-box-submit').click(function(){
    var formData_4 = {
                name: $('#input-s-6797f4a7-1471-4be2-8440-1027e50c51e1').val(),
                email: $('#input-s-886c19ea-1f29-4187-b148-04c93e7a6039').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-67827161-c5e3-4ad6-9f33-f67a742d0dca').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_four .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_four_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_4),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });

// new page form 4

  $('.custom_form_box_four-2 .shogun-form-box-submit').click(function(){
    var formData_44 = {
                name: $('#input-s-2d399482-ca47-4b6f-8a37-8f569e37adb9').val(),
                email: $('#input-s-ef719a3e-b09e-48da-a98f-9d6f0eab9662').val(),
                password: "",
                country_code: "+",
                phone_no: $('#input-s-7f49c20d-7fda-47a3-bf4b-2fce6c9c038f').val(),
                referral: " "
            };
    setTimeout(function(){
        if($('.custom_form_box_four-2 .shogun-form-success-msg span').css('visibility')=="visible"){
        $('.custom_form_box_four_app_div').css('display','block');
          $.ajax({
			url: "https://biofeedbackapps.com/dev/QuantumGenius/genius_web_signup",
            type: "POST",
            dataType: 'json',
            data: JSON.stringify(formData_44),
            success: function(response){
            },
            error: function(){
               alert("Form is not submitted !!! Invalid Data !!! ");
            }
          });
    }
    },1000);
  });
  if(window.location.pathname == '/pages/genius_biofeedback_affiliates'){
    $('header.section-header').css('margin-bottom','0px');
  }
  
  // $("#s-c9112089-099d-4b03-ab49-e8a44c14e81d").click(function(){
  //   $("#s-83706177-91b6-49c6-bb21-41568d77da49").show();
  //   $("#s-4f59c285-b176-4b1b-bd95-6808279178aa").show();
  //   $("#s-a8f975ae-c040-48c0-b585-2d18dc28c923").show();
  //   $("#s-869a8603-3a15-44ce-a225-b1f6e8a80d66").show();
  //   $("#s-4ddb706a-2679-4c82-acdf-498c4cdf53c3").show();
  //   $("#s-5e59deaa-aa96-4601-b5fb-5a19f443376a").show();
  //   $("#s-f546cd50-5b3a-46dc-adc1-ecfbf4f2a251").show();  
  //   $("#s-038eafce-74ac-4ee5-b7ba-14f951062df2").show();
  //   $("#s-8b9caa97-6e85-4078-bffa-1bf8e52d4765").show();
  //   $("#s-776aaa2d-f8fb-4a26-b45d-42ef3c311877").show();
  //   $("#s-472c7131-7b40-4074-95f8-f4c0bb469527").show();
  //   $("#s-c9f87578-53c1-46fb-a821-6c92fa52df11").show();
  //   $("#s-4e15375c-5dd2-4ba6-8861-b122a2587d7a").show();
  //   $("#s-3a2cf720-bae8-4891-a123-27fe8988ee48").show();
  //   $("#s-65cd78a8-2b62-4727-8b4a-2ea361111bf1").show();
  //   $("#s-abe03fbc-a5db-47aa-b78d-1a758f9010a4").show();
  //   $("#s-95512ec3-abc2-410c-81c2-dba24305ffb9").show();
  //   $("#s-9b6442b5-60ba-47d8-a934-8ed169fb55e4").show();
  //   $("#s-08b7ae6f-a854-4340-a1b4-2ef623697c5b").show();
  // });
  
});




    $(document).ready(function(){
            // Function to check and add the labels
            function addLabels() {
                // Check if the element with ID "#privy-widget-inner-modal-container" exists
                if ($('#privy-widget-inner-modal-container').length) {
                    // Array of input selectors and their placeholders
                    var inputs = [
                        { selector: '.hQLLxM.hQLLxM.hQLLxM input.sc-kAyceB.kcpuXH.text-medium[placeholder="Your Name"]', label: 'Your Name' },
                        { selector: '.hQLLxM.hQLLxM.hQLLxM input.sc-kAyceB.kcpuXH.text-medium[placeholder="Your Email"]', label: 'Your Email' },
                        { selector: '.hQLLxM.hQLLxM.hQLLxM input.sc-kAyceB.kcpuXH.text-medium[placeholder="Phone number"]', label: 'Phone number' }
                    ];

                    // Iterate over each input configuration
                    inputs.forEach(function(inputConfig) {
                        // Find the input field with the specified selector
                        var inputField = $(inputConfig.selector);
                        
                        // If the input field exists and no label has been added yet
                        if (inputField.length && inputField.prev('label').length === 0) {
                            // Create a new label element
                            var label = $('<label></label>').text(inputConfig.label);

                            // Insert the label before the input field
                            inputField.before(label);
                        }
                    });
                }
            }

            // Call the function every 5 seconds
            setInterval(addLabels, 500);
        });

  // Function to add client_reference_id to Stripe links from localStorage ref
  function addClientReferenceIdToStripeLinks() {
    try {
      // Check localStorage for ref value - exit early if not found
      var refValue = localStorage.getItem('ref');
      if (!refValue) {
        return;
      }

      // Find all anchor tags within stripe-btn containers that have Stripe links
      $('.stripe-btn a[data-id]').each(function() {
        var $anchor = $(this);
        
        // Skip if already processed
        if ($anchor.data('ref-processed')) {
          return;
        }
        
        var currentHref = $anchor.attr('href');
        
        // Verify it's a Stripe link
        if (!currentHref || currentHref.indexOf('stripe.com') === -1) {
          return;
        }

        var newHref;
        
        // Use modern URL API if available
        try {
          var url = new URL(currentHref);
          // Remove ref and sub_id parameters
          url.searchParams.delete('ref');
          url.searchParams.delete('sub_id');
          // Add or update client_reference_id parameter
          url.searchParams.set('client_reference_id', refValue);
          newHref = url.toString();
        } catch (e) {
          // Fallback: manually remove parameters and add client_reference_id
          // Remove ref parameter
          newHref = currentHref.replace(/[?&]ref=[^&]*/g, '');
          // Remove sub_id parameter (handle both &sub_id= and ?sub_id=)
          newHref = newHref.replace(/[?&]sub_id=[^&]*/g, '');
          
          // Clean up double ampersands or question marks
          newHref = newHref.replace(/&+/g, '&').replace(/\?&/, '?');
          
          // Add client_reference_id parameter
          var hasParams = newHref.indexOf('?') !== -1;
          var separator = hasParams ? '&' : '?';
          
          if (newHref.indexOf('client_reference_id=') !== -1) {
            // Replace existing client_reference_id
            newHref = newHref.replace(/client_reference_id=[^&]*/, 'client_reference_id=' + encodeURIComponent(refValue));
          } else {
            // Add new client_reference_id parameter
            newHref = newHref + separator + 'client_reference_id=' + encodeURIComponent(refValue);
          }
        }
        
        // Update href and mark as processed
        $anchor.attr('href', newHref).data('ref-processed', true);
      });
    } catch (error) {
      console.error('Error adding client_reference_id to Stripe links:', error);
    }
  }

  // Run on page load and watch for dynamic content
  $(document).ready(function() {
    // Initial run
    addClientReferenceIdToStripeLinks();
    
    // Run again after delay for dynamically loaded content
    setTimeout(addClientReferenceIdToStripeLinks, 1000);
    
    // Watch for dynamically added stripe-btn elements
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        var needsUpdate = false;
        
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.addedNodes.length > 0) {
            for (var j = 0; j < mutation.addedNodes.length; j++) {
              var node = mutation.addedNodes[j];
              // Check if added node is stripe-btn or contains stripe-btn
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('stripe-btn') || 
                    (node.querySelector && node.querySelector('.stripe-btn'))) {
                  needsUpdate = true;
                  break;
                }
              }
            }
            if (needsUpdate) break;
          }
        }
        
        if (needsUpdate) {
          addClientReferenceIdToStripeLinks();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });